import { render, staticRenderFns } from "./SoundPermission.vue?vue&type=template&id=3d370984&scoped=true&"
import script from "./SoundPermission.vue?vue&type=script&lang=js&"
export * from "./SoundPermission.vue?vue&type=script&lang=js&"
import style0 from "./SoundPermission.vue?vue&type=style&index=0&id=3d370984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d370984",
  null
  
)

export default component.exports